/* istanbul ignore file */
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import * as S from '../styles';
import TitleImageSrc from './images/blue-beetle-title.png';
import TitleImageColumnSrc from './images/blue-beetle-title-column.png';
import {
  Card,
  CinemaDate,
  DesktopImage,
  ImageWrapper,
  MobileImage,
  Section,
  SectionContent,
} from './styles';
import * as msgsData from './messages';
import _CinemaDateSvg from './images/cinema-date.svg';

const { msgs, ...localesWithMessages } = msgsData;

const PALETTE = 'blue';

const Learn: FC = () => {
  const intl = useIntl();
  const targetMsgs = useTargetMessages(localesWithMessages);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <Section>
      <SectionContent>
        <Card $palette={PALETTE}>
          <S.BottomContainer>
            <S.LeftSideContainer>
              <S.MissionCard
                mode="horizontal"
                mission="if-you-had-superpowers"
                image={TitleImageColumnSrc}
              />
            </S.LeftSideContainer>
            <S.RightSideContainer>
              <S.LeftSideSubTitle>
                {intl.formatMessage(msgs.blueBeetleCommunicate)}
                <S.Icon name="starsSet" />
              </S.LeftSideSubTitle>
              <S.LeftSideTitle>{intl.formatMessage(targetMsgs.bottomSectionTitle)}</S.LeftSideTitle>
              <S.LeftSideDescription>
                {intl.formatMessage(msgs.bottomSectionDescription)}
              </S.LeftSideDescription>
            </S.RightSideContainer>
          </S.BottomContainer>
        </Card>

        <ImageWrapper>
          <MobileImage alt="" src={TitleImageColumnSrc} fill sizes="100vw" />
          <DesktopImage alt="" src={TitleImageSrc} fill sizes="100vw" />
        </ImageWrapper>

        <CinemaDate Svg={_CinemaDateSvg} />

        <S.CTA>
          <Button
            analyticsEvent={eventGeneratorClickCta}
            buttonSize="large"
            buttonType="primary"
            disableMinWidth
            fullWidth="never"
            href={signUpHref}
          >
            {intl.formatMessage(targetMsgs.learningCta)}
          </Button>
        </S.CTA>

        <S.AllRightReserved>
          {intl.formatMessage(msgs.blueBeetleAllRightReserved)}
        </S.AllRightReserved>
      </SectionContent>
    </Section>
  );
};

export default Learn;
